import { render, staticRenderFns } from "./NoDataChart.vue?vue&type=template&id=f4c38e30&scoped=true&"
import script from "./NoDataChart.vue?vue&type=script&lang=ts&"
export * from "./NoDataChart.vue?vue&type=script&lang=ts&"
import style0 from "./NoDataChart.vue?vue&type=style&index=0&id=f4c38e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c38e30",
  null
  
)

export default component.exports